import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import {
	useCollectionsIntroductionDismissed,
	useCollectionsIntroductionPrerequisiteDismissalsMet,
} from '../../../../controllers/selectors/collections-hooks.tsx';
import { useProductUsageStartTimestamp } from '../../../../controllers/selectors/product-usage-start-timestamp-hooks.tsx';

export const useIsLicensedUser = (): boolean => {
	const { hasProductDiscoveryAccess } = useApplicationPermissions() ?? {};
	return Boolean(hasProductDiscoveryAccess);
};

export const checkIfOlderThanNDays = (productStartTimestamp?: string, days = 7) => {
	if (!productStartTimestamp) {
		return false;
	}

	const daysInMs = days * 24 * 60 * 60 * 1000;
	const currentDate = new Date();
	const productAge = currentDate.getTime() - new Date(productStartTimestamp).getTime();
	return productAge > daysInMs;
};

/**
 * Hook to determine if the roadmap introduction spotlight should be shown
 * This hook was implemented based on RoadmapIntroductionSpotlight logic
 * src/packages/polaris/apps/ideas/src/ui/create-issue-interceptor/index.tsx
 * This hook checks:
 * - User licensing status
 * - Whether already on roadmaps page
 * - Dismissal state
 * - Prerequisites met
 * - User age requirements
 */
export const useShouldShowRoadmapsIntroductionSpotlight = (): boolean => {
	const isLicensedUser = useIsLicensedUser();
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const isAlreadyInRoadmaps = window?.location.href.includes('roadmap');

	const isIntroductionDismissed = useCollectionsIntroductionDismissed();
	const arePrerequisiteDismissalsMet = useCollectionsIntroductionPrerequisiteDismissalsMet();
	const productUsageStartTimestamp = useProductUsageStartTimestamp();

	// Determine if should show the spotlight
	return !(
		isAlreadyInRoadmaps ||
		!isLicensedUser ||
		isIntroductionDismissed === undefined ||
		isIntroductionDismissed ||
		!arePrerequisiteDismissalsMet ||
		!checkIfOlderThanNDays(productUsageStartTimestamp)
	);
};
